// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-image-window {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.dynamic-image-window__image {
    position: absolute;
    user-select: none;
    pointer-events: none;
    transition-property: left, top;
    transition-timing-function: ease-in-out;
    will-change: left, top;
}

.dynamic-image-window > span {
    color: white;
    position: absolute;
    z-index: 1;
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/css/DynamicImageWindow.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB","sourcesContent":[".dynamic-image-window {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.dynamic-image-window__image {\r\n    position: absolute;\r\n    user-select: none;\r\n    pointer-events: none;\r\n    transition-property: left, top;\r\n    transition-timing-function: ease-in-out;\r\n    will-change: left, top;\r\n}\r\n\r\n.dynamic-image-window > span {\r\n    color: white;\r\n    position: absolute;\r\n    z-index: 1;\r\n    display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
